// extracted by mini-css-extract-plugin
export default {"create-title":"tech-card-page_create-title__KwhCy","edit-title":"tech-card-page_edit-title__ROCPP","tech-card__title":"tech-card-page_tech-card__title__qBD9V"};